"use strict";

import { gsap } from "gsap";

let peopleItem = document.querySelectorAll('.people__item');

const filterBtn = document.querySelectorAll(".filter__item");
filterBtn.forEach(btn => {
  btn.addEventListener(
    'click',
    (e) => {
      document.querySelector(".filter__item.is-active").classList.remove("is-active");

      let currentTarget = e.currentTarget;
      currentTarget.classList.add("is-active");
      if(currentTarget.dataset.group == "all") {
        peopleItem.forEach(item => {
          if(item.classList.contains("hidden")) item.classList.remove("hidden");
        });
      }
      else {
        peopleItem.forEach(item => {
          if(item.dataset.groups != currentTarget.dataset.group ) {
            item.classList.add("hidden");
          }
          else {
            item.classList.remove("hidden");
          }
        });
      }
    },
    false
  )
});

function center() {
  let activeItem = document.querySelectorAll(".shuffle-item--visible");
  let lastItem = activeItem[activeItem.length - 1];
  gsap
  .timeline()
  .to(lastItem, { xPercent: 50, duration: 0.01 }, .2);

}
